import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://optrenex.com";

const META = {
  "/": {
    title: "Optrenex International — Global B2B Video Game Distributor | Dubai & Mumbai",
    description:
      "Licensed B2B distributor of PlayStation, Xbox, Nintendo, Steam Deck and gaming accessories. Wholesale supply, API integration, dropshipping and white-label fulfilment from Dubai and Mumbai.",
  },
  "/about": {
    title: "About Optrenex International | Licensed Gaming Distribution Group",
    description:
      "Optrenex International is a licensed gaming distribution group with entities in Dubai (UAE) and Mumbai (India), backed by Advani Holdings.",
  },
  "/global-presence": {
    title: "Global Presence | Optrenex Offices in Dubai & Mumbai",
    description:
      "Our Dubai head office and Mumbai registered office power licensed gaming import, export and distribution across 41 countries.",
  },
  "/portfolio": {
    title: "Product Portfolio | Consoles, Games, Digital Codes & Accessories",
    description:
      "Explore the Optrenex wholesale portfolio: consoles, video games, digital codes, controllers, storage and gaming accessories for trade buyers.",
  },
  "/become-customer": {
    title: "Become a Customer | Apply for an Optrenex Trade Account",
    description:
      "Apply for a verified Optrenex B2B trade account to access wholesale pricing, live stock and volume tiers on gaming hardware and software.",
  },
  "/become-supplier": {
    title: "Become a Supplier | Partner with Optrenex International",
    description:
      "Supply gaming hardware, software or digital codes to Optrenex and reach retailers and distributors across 41 countries.",
  },
  "/contact": {
    title: "Contact Optrenex International | Dubai & Mumbai Offices",
    description:
      "Contact the Optrenex trade desk in Dubai or Mumbai by phone, WhatsApp or email for wholesale gaming enquiries.",
  },
};

function setTag(selector, create, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export default function RouteSeo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const url = pathname === "/" ? `${SITE}/` : `${SITE}${pathname}`;
    const meta = META[pathname];
    if (!meta) {
      setTag('link[rel="canonical"]', () => {
        const l = document.createElement("link");
        l.setAttribute("rel", "canonical");
        return l;
      }, "href", url);
      return;
    }

    document.title = meta.title;
    setTag('meta[name="description"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("name", "description");
      return m;
    }, "content", meta.description);
    setTag('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    }, "href", url);
    setTag('meta[property="og:url"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:url");
      return m;
    }, "content", url);
    setTag('meta[property="og:title"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("property", "og:title");
      return m;
    }, "content", meta.title);
  }, [pathname]);

  return null;
}
